<template>
    <div style="padding: 0 10px;">
      <headful
            title="Caseen - Interactive Clinical Case Platform"
      />
      <h2>Welcome to Caseen</h2>
      <h3>Interactive Clinical Cases Created By You!</h3>
      <h4 style="max-width: 750px; margin: auto;">
        Caseen (pronounced Case-Seen or Casein) allows educators to create their own interactive clinical cases studies and share them with the community.
        Learners work through these cases in order to gain exposure to diverse clinical reasoning scenarios, construct a robust collection of illness scripts, and become more experienced and effective clinicians.
        Together we can create an open repository of combined clinical experience that can help us all become better healthcare providers for our patients.
        <br><br>
        For more information on the scholarship guiding the design of this software, please review our <a href="https://docs.google.com/document/d/18G9nRBLEV1xvM8UQS4kw_aQ7jVS_GNmnstWmGbclzzY/edit?usp=sharing" target="_blank">white paper</a>. 
        <br><br>
      </h4>
      <hr>
      <br>
      <div v-if="$store.state.jwtToken">
        <md-button to="cases" class="md-raised md-primary">Get Started Practicing Cases</md-button>
        <br><br>
        <md-button to="editor" class="md-raised md-primary">Get Started Creating Cases</md-button>
        <br><br>
      </div>
      <div v-else>
        <md-button to="login" class="md-raised md-primary">Login</md-button>
        <br><br>
      </div>
      <hr>
      <br>
      <h1>Learning with Caseen:</h1>
      <br><br>
      <video controls loop style="border: 3px solid #555; border-radius: 5px; max-width: 800px; width: 100%;" id="learner-demo-vid">
        <source src="vid/learning.mp4" type="video/mp4">
      </video>
      <hr>
      <br>
      <h1>Authoring with Caseen:</h1>
      <br><br>
      <video controls loop style="border: 3px solid #555; border-radius: 5px; max-width: 800px; width: 100%;" id="authoring-demo-vid">
        <source src="vid/authoring.mp4" type="video/mp4">
      </video>
    </div>
</template>

<script>
export default {
  name: 'HomePage',
  props: {
  },
  mounted: function() {
    this.$nextTick(() => {
      document.getElementById("learner-demo-vid").addEventListener("mouseover", function(){
        document.getElementById("learner-demo-vid").play()
        document.getElementById("authoring-demo-vid").pause()
      })
      document.getElementById("authoring-demo-vid").addEventListener("mouseover", function(){
        document.getElementById("authoring-demo-vid").play()
        document.getElementById("learner-demo-vid").pause()
      })
      if(this.$store.state.jwtToken && !this.$store.state.jwtClaims.acceptedTOS){
        this.$router.push("/tos")
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  margin-bottom: 8px;
}
h3 {
  margin: 0 0 30px 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
